<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Make an Inventory Adjustment</p>
          <button
            class="delete"
            aria-label="close"
            @click="close(true)">
          </button>
        </header>

        <v-form class="modal-card-body" :valid.sync="valid">

          <div class="field">
            <label class="label">Project Being Adjusted</label>
            <span>{{ projectInventory.project.project_name }}</span>
          </div>

          <div class="field">
            <label class="label">Product Being Adjusted</label>
            <span>{{ projectInventory.inventory.product_master.name }}</span>
          </div>

          <div class="field">
            <label class="label">Current Quantity Available</label>
            <span>{{ parseInt(projectInventory.qty_available) + parseInt(difference) }}</span>
          </div>

          <div class="field">
            <label class="label">Adjustment*</label>
            <v-text-field
              required
              placeholder="Enter quantity adjustment"
              type="number"
              v-model="difference">
            </v-text-field>
          </div>

        </v-form>

        <footer class="modal-card-foot">
          <button 
            :disabled="!valid"
            class="button is-primary" 
            @click.stop="adjust()">
            Adjust Inventory
          </button>
          <button 
            class="button" 
            @click.stop="close(true)">
            Cancel
          </button>
        </footer>

      </div>
    </div>

  </div>
</template>

<script>
import VForm from '@/components/base/VForm'
import VTextField from '@/components/base/VTextField'

import { mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    },
    projectInventory: {
      type: Object
    }
  },
  components: { 
    VForm,
    VTextField,
  },
  data() {
    return {
      difference: 0,
      valid: false
    }
  },
  methods: {
    ...mapActions("inventoryProject", ["adjustInventory"]),
    adjust() {
      this.adjustInventory({
        project_id: this.projectInventory.project.id,
        stocking_unit_id: this.projectInventory.inventory.stocking_unit_id,
        difference: this.difference
      }).then(() => this.close(true))
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>
